// react component to create a new portfolio
import React, {
  createContext, useContext,
  useState
} from 'react';

import { NoPersonWarning } from '../../components';
import { IdentityContext } from '../../context';
import { useIndex } from '../../hooks';

import { NewWillGuard } from './new-will-guard';

export const NewWillContext = createContext(null);

export function NewWillProvider() {
  const { person } = useContext(IdentityContext);
  const { data: wills, loading, update } = useIndex('wills', { person_id: person?.id });
  // check if user has a will
  const [ initLoad, setInitLoad ] = useState(true);

  if (loading) {
    return <div>Loading will...</div>;
  }

  if (!person) {
    return <NoPersonWarning />;
  }

  const will = wills ? wills[0] : null;

  return (
    <NewWillContext.Provider value={{ will, update }}>
      <NewWillGuard initLoad={initLoad} setInitLoad={setInitLoad} />
    </NewWillContext.Provider>
  );
}